module.exports = __webpack_public_path__ + "files/da63366db0ec5f3084d9c977e93de777.svg";